import { render, staticRenderFns } from "./modalComentarios.vue?vue&type=template&id=507556d6&scoped=true&"
import script from "./modalComentarios.vue?vue&type=script&lang=js&"
export * from "./modalComentarios.vue?vue&type=script&lang=js&"
import style0 from "./modalComentarios.vue?vue&type=style&index=0&id=507556d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "507556d6",
  null
  
)

export default component.exports